import $ from 'jquery';
import  './markup-menu';

import 'jquery.maskedinput/src/jquery.maskedinput';
import 'jquery-mousewheel';
import svgUseIt from 'svg-use-it';
import 'jquery-touchswipe'

import main from './components/main'
import sliders from './components/sliders'
import map from './components/map'
import Tabs from './components/tabs';
import animation from './components/animation'

global.$ = global.jQuery;
global.$ = $;
document.addEventListener("DOMContentLoaded", () => {
  svgUseIt();
  sliders();
  main();
  animation();

  global.customTabs = new Tabs();

  if (document.getElementById('map')) {
    map();
  }

  $('input[type="tel"]').mask('+99 (999) 999-99-99');

  if (window.innerWidth <= 460) {
    $('.main-nav__swipe-block').swipe({
      swipeStatus(event, phase, direction, distance, duration, fingers) {
        if (phase === 'move' && direction === 'down') {
          $('.main-nav').removeClass('active')
          $('body').removeClass('holder-block')
          $('.menu-button').removeClass('active')
          return false;
        }
      }
    })
  }
});


// WEBPACK FOOTER //
// app/scripts/index.js